/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineFilterViewModel } from "../types/ClassroomDisciplineFilterViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";

export const classroomDisciplineFilterViewModelSchema = z.object({
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
  courseId: z.number().int().nullish(),
  classStudentId: z.number().int().nullish(),
  classModuleId: z.number().int().nullish(),
  disciplineId: z.number().int().nullish(),
  poloId: z.number().int().nullish(),
  status: z
    .array(
      z
        .lazy(() => eClassRoomDisciplinesStatusSchema)
        .describe(
          "1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | ",
        ),
    )
    .nullish(),
  dateStart: z.string().datetime().nullish(),
  dateEnd: z.string().datetime().nullish(),
  teacher: z.string().nullish(),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<ClassroomDisciplineFilterViewModel>;
